import type { ModuleWithProviders } from '@angular/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FmCheckboxComponent } from './fm-checkbox.component';

@NgModule({
  imports: [CommonModule],
  exports: [FmCheckboxComponent],
  declarations: [FmCheckboxComponent],
})
export class FmCheckboxModule {
  static forRoot(): ModuleWithProviders<FmCheckboxModule> {
    return {
      ngModule: FmCheckboxModule,
    };
  }
}
